import { render, staticRenderFns } from "./JEditor.vue?vue&type=template&id=cd40436c&scoped=true"
import script from "./JEditor.vue?vue&type=script&lang=js"
export * from "./JEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd40436c",
  null
  
)

export default component.exports